var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNactLogoTransparentBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2900,
    height: 900,
    viewBox: "0 0 2900 900",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1450 450)",
    id: "e5d9e376-227e-49b6-885a-2b3505d4155f"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -1450,
    y: -450,
    rx: 0,
    ry: 0,
    width: 2900,
    height: 900
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)",
    id: "de08caf2-984a-489a-abe0-c321dcfc61ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 1451 450.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(239,102,0)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -400,
    y: -125,
    rx: 0,
    ry: 0,
    width: 800,
    height: 250
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 956.71 465.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-253.65, -129.05)",
    d: "M269.6 150.5 236.6 119.5 236.6 151.7 227.2 151.7 227.2 109.6C227.2 106.7 229.4 105.4 232.6 105.4 234.9 105.4 236.3 106.1 237.3 107.1L270.5 139.1 270.5 106.4 280.1 106.4 280.1 148.5C280.1 151.5 278 152.7 275.1 152.7 273 152.7 271.2 152.1 269.6 150.5z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 1174.97 463.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-317.6, -128.5)",
    d: "M333.1 141.2 301.8 141.2 295.4 151.6 283.8 151.6 310.1 109.8C311.7 107.2 313.6 105.4 317.7 105.4 321.7 105.4 323.7 107.3 325.3 109.8L351.4 151.6 339.7 151.6 333.1 141.2zM306.5 133.5 328.4 133.5 317.5 115.7 306.5 133.5z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 1378.61 465.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-377.2, -129.15)",
    d: "M370.1 151.7C356.8 151.7 352.9 147.6 352.9 136.2L352.9 122C352.9 110.6 356.8 106.5 370.1 106.5L401.5 106.5 401.5 115.2 370.6 115.2C364.4 115.2 362.9 117 362.9 122.6L362.9 135.9C362.9 141.5 364.4 143.2 370.7 143.2L401.5 143.2 401.5 151.8 370.1 151.8z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 1556.69 465.81)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-429.35, -129.1)",
    d: "M424.3 151.7 424.3 115.2 405.3 115.2 405.3 106.5 453.4 106.5 453.4 115.2 434.4 115.2 434.4 151.7 424.3 151.7z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 906.75 638.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-238.95, -179.75)",
    d: "M227.7 196.7 227.7 162.8 250.2 162.8 250.2 166.1 231.6 166.1 231.6 177.7 249.4 177.7 249.4 180.9 231.6 180.9 231.6 193.4 250.2 193.4 250.2 196.7 227.7 196.7z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 1074.31 638.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-288.05, -179.75)",
    d: "M272.9 162.8 279.5 162.8 299.1 193.8 299.2 193.8 299.2 162.8 303.2 162.8 303.2 196.7 296.7 196.7 277 166 276.9 166 276.9 196.7 272.9 196.7 272.9 162.8z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 1253.95 638.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-340.65, -179.75)",
    d: "M355.1 187.3C355.1 191.1 354.2 193.7 352.4 195.1 351.6 195.7 350.6 196.2 349.6 196.4 348.6 196.6 347.4 196.9 346.2 196.9 345 197 343.3 197 341.1 197L338.3 197C336.9 197 335.7 196.9 334.6 196.8 333.5 196.7 332.5 196.5 331.5 196.1 330.5 195.8 329.7 195.2 329 194.6 328 193.7 327.3 192.5 326.9 191 326.4 189.5 326.2 187.6 326.2 185.2L326.2 174.1C326.2 170.1 327.1 167.1 329 165.1 329.8 164.3 330.9 163.6 332.2 163.2 333.5 162.8 334.9 162.5 336.5 162.5L346 162.5C348.9 162.5 351.1 163.1 352.7 164.4 354.3 165.7 355.1 167.6 355.1 170.1L355.1 172.7 351.2 172.7 351.2 171.3C351.2 169.3 350.9 168 350.2 167.4 349.7 166.9 349 166.5 348.2 166.3 347.4 166.1 346.4 166 345.3 166 344.2 166 343 166 341.8 166 340 166 338.6 166 337.4 166 336.2 166 335.2 166.1 334.4 166.3 333.6 166.5 332.8 166.8 332.1 167.3 331.5 167.8 331 168.6 330.7 169.6 330.4 170.6 330.3 172.1 330.3 174.1L330.3 186.4C330.3 189.3 331 191.3 332.4 192.3 333.2 192.9 334.1 193.2 335.1 193.4 336.1 193.6 337.4 193.7 338.9 193.8 339.4 193.7 340.1 193.7 341 193.7 341.9 193.7 342.6 193.7 343 193.8 344.8 193.7 346.2 193.6 347.2 193.4 348.3 193.2 349.1 192.9 349.8 192.4 350.8 191.7 351.2 190.1 351.2 187.5L351.2 183.3 340 183.3 340 179.9 355.1 179.9 355.1 187.3z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 1387.31 638.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-379.65, -179.75)",
    d: "M377.7 162.8 381.6 162.8 381.6 196.7 377.7 196.7 377.7 162.8z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 1528.48 638.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-421.05, -179.75)",
    d: "M405.9 162.8 412.5 162.8 432.1 193.8 432.2 193.8 432.2 162.8 436.2 162.8 436.2 196.7 429.7 196.7 410 166 409.9 166 409.9 196.7 405.9 196.7 405.9 162.8z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 1696.86 638.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-470.35, -179.75)",
    d: "M459.1 196.7 459.1 162.8 481.6 162.8 481.6 166.1 463 166.1 463 177.7 480.8 177.7 480.8 180.9 463 180.9 463 193.4 481.6 193.4 481.6 196.7 459.1 196.7z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 1846.91 638.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-514.3, -179.75)",
    d: "M503 196.7 503 162.8 525.5 162.8 525.5 166.1 507 166.1 507 177.7 524.8 177.7 524.8 180.9 507 180.9 507 193.4 525.6 193.4 525.6 196.7 503 196.7z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 2009.25 638.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-561.85, -179.75)",
    d: "M565.1 162.8C569 162.8 571.7 163.6 573.3 165.3 574.7 166.7 575.4 169.2 575.4 172.9 575.4 175.9 574.9 178 574 179.2 573 180.5 571.4 181.2 569.3 181.5L569.3 181.6C570.4 181.7 571.4 182 572.2 182.6 573 183.2 573.7 183.8 574.2 184.7 574.7 185.6 574.9 186.5 574.9 187.6L574.9 196.7 570.9 196.7 570.9 189.3C570.9 187.1 570.5 185.5 569.6 184.6 568.8 183.7 567.2 183.2 564.8 183.2L552.2 183.2 552.2 196.7 548.3 196.7 548.3 162.8 565.1 162.8zM565.2 166.2 552.3 166.2 552.3 179.8 564.7 179.8C566 179.8 567 179.7 567.9 179.5 568.8 179.3 569.5 178.9 570.1 178.3 571 177.4 571.4 175.8 571.4 173.4L571.4 172.3C571.4 170.1 571.1 168.6 570.5 167.9 569.5 166.7 567.7 166.2 565.2 166.2z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 2142.93 638.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-600.95, -179.75)",
    d: "M599 162.8 602.9 162.8 602.9 196.7 599 196.7 599 162.8z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 2283.77 638.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-642.25, -179.75)",
    d: "M627.1 162.8 633.7 162.8 653.3 193.8 653.4 193.8 653.4 162.8 657.4 162.8 657.4 196.7 651 196.7 631.2 166 631.1 166 631.1 196.7 627.1 196.7 627.1 162.8z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 2463.39 638.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-694.85, -179.75)",
    d: "M709.3 187.3C709.3 191.1 708.4 193.7 706.6 195.1 705.8 195.7 704.8 196.2 703.8 196.4 702.8 196.6 701.6 196.9 700.4 196.9 699.2 197 697.5 197 695.3 197L692.5 197C691.1 197 689.9 196.9 688.8 196.8 687.7 196.7 686.7 196.5 685.7 196.1 684.7 195.8 683.9 195.2 683.2 194.6 682.2 193.7 681.5 192.5 681.1 191 680.7 189.5 680.4 187.6 680.4 185.2L680.4 174.1C680.4 170.1 681.3 167.1 683.2 165.1 684 164.3 685.1 163.6 686.4 163.2 687.7 162.8 689.1 162.5 690.7 162.5L700.2 162.5C703.1 162.5 705.3 163.1 706.9 164.4 708.5 165.7 709.3 167.6 709.3 170.1L709.3 172.7 705.4 172.7 705.4 171.3C705.4 169.3 705.1 168 704.4 167.4 703.9 166.9 703.2 166.5 702.4 166.3 701.6 166.1 700.6 166 699.5 166 698.4 166 697.2 166 696 166 694.2 166 692.8 166 691.6 166 690.4 166 689.4 166.1 688.6 166.3 687.8 166.5 687 166.8 686.3 167.3 685.7 167.8 685.2 168.6 684.9 169.6 684.6 170.6 684.5 172.1 684.5 174.1L684.5 186.4C684.5 189.3 685.2 191.3 686.6 192.3 687.4 192.9 688.3 193.2 689.3 193.4 690.3 193.6 691.6 193.7 693.1 193.8 693.6 193.7 694.3 193.7 695.2 193.7 696.1 193.7 696.8 193.7 697.2 193.8 699 193.7 700.4 193.6 701.4 193.4 702.5 193.2 703.3 192.9 704 192.4 705 191.7 705.4 190.1 705.4 187.5L705.4 183.3 694.2 183.3 694.2 179.9 709.3 179.9 709.3 187.3z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 661.3 505.38)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "6.15,26.6 6.15,-26.6 -6.15,-26.6 -6.15,14.4 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4 0 0 3.4 580.11 449.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-143.55, -124.45)",
    d: "M 193.1 189.1 L 178.6 189.1 L 178.6 192 L 192.79999999999998 192 C 191.49999999999997 198.3 185.89999999999998 203 179.2 203 C 171.5 203 165.29999999999998 196.8 165.29999999999998 189.1 C 165.29999999999998 181.4 171.49999999999997 175.2 179.2 175.2 C 185.6 175.2 191 179.6 192.6 185.5 L 195.7 185.5 C 194.1 177.9 187.29999999999998 172.2 179.2 172.2 C 176 172.2 172.89999999999998 173.1 170.39999999999998 174.7 L 102.69999999999997 107.29999999999998 C 103.59999999999998 105.79999999999998 104.29999999999997 104.19999999999999 104.69999999999997 102.39999999999998 L 182.79999999999995 102.39999999999998 C 184.99999999999994 109.09999999999998 191.39999999999995 113.99999999999997 198.79999999999995 113.99999999999997 C 208.09999999999997 113.99999999999997 215.69999999999996 106.39999999999998 215.69999999999996 97.09999999999997 C 215.69999999999996 87.79999999999997 208.09999999999997 80.19999999999996 198.79999999999995 80.19999999999996 C 190.29999999999995 80.19999999999996 183.29999999999995 86.39999999999996 182.09999999999997 94.59999999999997 L 104.69999999999996 94.59999999999997 C 104.19999999999996 92.39999999999996 103.19999999999996 90.39999999999996 101.99999999999996 88.69999999999996 L 112.89999999999996 77.79999999999995 C 116.19999999999996 80.29999999999995 120.19999999999996 81.69999999999996 124.59999999999997 81.69999999999996 C 135.29999999999995 81.69999999999996 143.99999999999997 72.99999999999996 143.99999999999997 62.29999999999996 C 143.99999999999997 51.599999999999966 135.29999999999998 42.89999999999996 124.59999999999997 42.89999999999996 C 113.89999999999996 42.89999999999996 105.19999999999996 51.599999999999966 105.19999999999996 62.29999999999996 C 105.19999999999996 66.69999999999996 106.69999999999996 70.69999999999996 109.09999999999997 73.99999999999996 L 98.2 84.8 C 95.4 82.8 92 81.6 88.3 81.6 C 79 81.6 71.4 89.19999999999999 71.4 98.5 C 71.4 107.8 79 115.4 88.30000000000001 115.4 C 91.50000000000001 115.4 94.60000000000001 114.5 97.10000000000001 112.9 L 103.9 119.7 L 103.9 184.3 L 116 184.3 L 116 131.8 L 164.8 180.3 C 163.20000000000002 182.9 162.3 185.9 162.3 189.10000000000002 C 162.3 198.40000000000003 169.9 206.00000000000003 179.20000000000002 206.00000000000003 C 188.50000000000003 206.00000000000003 196.10000000000002 198.40000000000003 196.10000000000002 189.10000000000002 L 193.1 189.1 C 193.1 189.1 193.1 189.1 193.1 189.1 z M 124.6 48.7 C 132 48.7 138.1 54.800000000000004 138.1 62.2 C 138.1 69.60000000000001 132 75.7 124.6 75.7 C 117.19999999999999 75.7 111.1 69.60000000000001 111.1 62.2 C 111.1 54.7 117.2 48.7 124.6 48.7 z M 90.3 106.1 C 89.6 106.3 89 106.39999999999999 88.3 106.39999999999999 C 87.1 106.39999999999999 86 106.1 85 105.69999999999999 C 83.3 104.89999999999999 82 103.6 81.2 101.89999999999999 C 80.7 100.89999999999999 80.5 99.8 80.5 98.6 C 80.5 94.19999999999999 84 90.69999999999999 88.4 90.69999999999999 C 89.60000000000001 90.69999999999999 90.7 90.99999999999999 91.7 91.39999999999999 C 93.2 92.1 94.4 93.19999999999999 95.2 94.6 C 95.3 94.8 95.4 95 95.5 95.19999999999999 C 96 96.19999999999999 96.2 97.29999999999998 96.2 98.49999999999999 C 96.2 99.19999999999999 96.10000000000001 99.89999999999999 95.9 100.49999999999999 C 95.7 101.19999999999999 95.5 101.79999999999998 95.10000000000001 102.39999999999999 C 94.1 104.2 92.4 105.6 90.3 106.1 z M 198.8 89.2 C 203.20000000000002 89.2 206.70000000000002 92.7 206.70000000000002 97.10000000000001 C 206.70000000000002 101.50000000000001 203.20000000000002 105.00000000000001 198.8 105.00000000000001 C 196.5 105.00000000000001 194.5 104.00000000000001 193 102.50000000000001 C 191.7 101.10000000000001 190.9 99.20000000000002 190.9 97.10000000000001 C 190.9 96.2 191.1 95.4 191.3 94.60000000000001 C 192.4 91.5 195.3 89.2 198.8 89.2 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNactLogoTransparentBg);
export default __webpack_public_path__ + "static/media/nact-logo-transparent-bg.3eb15a58ff668b7d2cf381b431c5042f.svg";
export { ForwardRef as ReactComponent };